import { spreadSearchQuery } from "../../../assets/utils/utility";
import ApiCaller from "../../Connection/ApiCaller";
const apiEndpoint = "web-users";

const onFetchListSid = async (data) => {
    return await ApiCaller.post("/ViewResult/GetListSid",data);
  };

const GetResultPatient = async (data) => {
  let q = spreadSearchQuery(data);
  return await ApiCaller.get(`ViewResult/GetResultPatient?${q}`);
};

export { 
    onFetchListSid,
    GetResultPatient
 };
